module.exports = __webpack_public_path__ + "nc_static/media/dd_file_management.6bc67adb.svg";